module.exports = __webpack_public_path__ + "static/media/cobrefacilHG.6fbef3b8.svg";